import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import EnvBadge from './EnvBadge';
import './MainScreen.css';

interface MainScreenProps {
  onNavigateToLicense: () => void;
  onNavigateToQuota: () => void;
  onNavigateToSar: () => void;
}

const MainScreen: React.FC<MainScreenProps> = ({
  onNavigateToLicense,
  onNavigateToQuota,
  onNavigateToSar,
}) => {
  const { logout, hasProdSession } = useAuth();

  const handleLogout = () => {
    logout();
  };

  // Quota & SAR hit prod hosts; in a DEV-only session there is no prod session, so disable them.
  const prodDisabledHint = 'Unavailable in a DEV-only session. Sign in as PROD to use this.';

  return (
    <div className="main-container">
      <header className="main-header">
        <h1>RainMaker Admin Dashboard</h1>
        <div className="header-actions">
          <EnvBadge />
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
      </header>

      <main className="main-content">
        <div className="dashboard-grid">
          <div className="dashboard-card" onClick={onNavigateToLicense}>
            <div className="card-icon">📄</div>
            <h2>License Management</h2>
            <p>Manage customer licenses, quotas, and features</p>
          </div>

          <div
            className={`dashboard-card ${hasProdSession ? '' : 'dashboard-card-disabled'}`}
            onClick={hasProdSession ? onNavigateToQuota : undefined}
            title={hasProdSession ? undefined : prodDisabledHint}
          >
            <div className="card-icon">📊</div>
            <h2>Quota Management</h2>
            <p>{hasProdSession ? 'Update user quotas and ESP32 whitelist settings' : prodDisabledHint}</p>
          </div>

          <div
            className={`dashboard-card ${hasProdSession ? '' : 'dashboard-card-disabled'}`}
            onClick={hasProdSession ? onNavigateToSar : undefined}
            title={hasProdSession ? undefined : prodDisabledHint}
          >
            <div className="card-icon">🔐</div>
            <h2>SAR Management</h2>
            <p>{hasProdSession ? 'Manage Skills Access Requests and notifications' : prodDisabledHint}</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MainScreen;